import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";

function Loader() {
  return (
    <div className="loader">
      <FontAwesomeIcon className="icon" icon={["fas", "circle-notch"]} />
    </div>
  );
}

export default Loader;
